import { useEffect } from 'react'

/** Asks the browser to confirm a reload or tab close while `active` (PD-1813). */
export function useWarnBeforeUnload(active: boolean): void {
  useEffect(() => {
    if (!active) return
    const warn = (event: BeforeUnloadEvent) => event.preventDefault()
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [active])
}
